import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import LogTable from './components/LogTable';
import ProgressFullScreen from '../../components/Compartilhados/ProgressFullScreen';
import SnackbarCustom from '../../components/Compartilhados/Snackbar';
import { NotFound as NotFoundView } from '../index';
import { isAuthenticated } from '../../helpers/authenticate';
import { Values } from '../../values/Values';
import BottomScrollListener from 'react-bottom-scroll-listener';
import { obterTodasConexoesUsuarios } from '../../services/ConexaoUsuarioService';
import { obterLogs } from '../../services/LogService';
import ExcecaoView from '../ExcecaoView';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  pagination: {
    marginTop: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  divFab:{
    zIndex: 2
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
}));
function LogList( { history } ) {
  const classes = useStyles();
  const [loading, setLoading] = React.useState(false);
  let [logs, setLogs] = useState([]);
  const [showMessageSnack, setShowMessageSnack] = useState(false);
  const [messageSnack, setMessageSnack] = useState('');
  const [typeSnack, setTypeSnack] = useState('success');
  let [page, setPage] = useState(1);
  const [fimLista, setFimLista] = useState(false);

  useEffect(() => {
    function checkAuth() {
      isAuthenticated(history);
    }
    checkAuth();
  }, []);

  useEffect(() => {
    carregarLogs();
  }, []);

  async function carregarLogs() {
    try{
      setLoading(true);
      const dados = await obterLogs(page, Values.limiteRegistroLista);
      if(dados.isSuccess){
        setPage(page + 1);
        let retorno = logs;
        if(dados.result.length !== 0){
          for(let i = 0, size = dados.result.length; i < size; i++){
            dados.result[i].on_mouse_over = false;
            retorno.push(dados.result[i]);
          }
          setLogs(retorno);
        }
        else {
          if (page === 1) {
            setLoading(false);
            setTypeSnack('warning');
            setMessageSnack('Não há logs registrados');
            setShowMessageSnack(true);
          } else {
            setFimLista(true);
          }
        }
      }
      else{
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack(dados.message);
        setShowMessageSnack(true);
      }
      setLoading(false);
    }
    catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch);
      setShowMessageSnack(true);

    }
  }

  async function carregarMais() {
    if (!fimLista) {
      await carregarLogs();
    }
  }


  return (
    <BottomScrollListener
      onBottom={e => carregarMais()}
      offset={50}
      debounce={100}
    >
      <div
        className={classes.root}
      >

        <SnackbarCustom
          verticalOrientation='bottom'
          horizontalOrientation='center'
          open={showMessageSnack}
          setOpen={setShowMessageSnack}
          message={messageSnack}
          duration={2000}
          type={typeSnack}
        />
        <div className={classes.content}>
          <ProgressFullScreen
            open={loading}
            setOpen={setLoading}
          />
          {
            logs.length ?
              <LogTable
                logs={logs}
                setLogs={setLogs}
                setShowMessageSnack={setShowMessageSnack}
                setMessageSnack={setMessageSnack}
                setTypeSnack={setTypeSnack}
              />
              :
              <ExcecaoView
               caminhoImagem={'/images/erroGeral.png'}
               titulo={'SEM REGISTROS'}
               descricao={'Não há nenhum registro de LOG registrado.'}
              />
          }
        </div>
      </div>
    </BottomScrollListener>

  );
};

export default LogList;
